module.exports = ".not-found-message{\r\n  margin-top: 150px  \r\n}\r\n\r\nh3 { text-align: center }"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.css
// module id = ./src/app/not-found/not-found.component.css
// module chunks = main